<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ ['直连文件拆分管理', '网站文件拆分管理', 'FTP文件拆分管理', '接口文件拆分管理'][parseInt($route.query.type)] }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span @click="$router.go(-1)" style="cursor: pointer;">拆分设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>操作日志</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      操作日志
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" v-model="form" size="small" label-suffix="：">
            <!-- <el-form-item label="经销商筛选">
              <el-select :clearable="true" v-model="form.client_id" placeholder="选择经销商">
                <el-option v-for="item in companyList" :key="item.client_id" :label="item.company_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="操作时间">
              <el-date-picker v-model="form.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.search_text" class="search-text" size="small" style="width: 560px;"
                placeholder="请输入操作人名称/商业名称/商业编码/子公司编码/子公司名称/映射编码/映射名称">
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="function_name" label="操作功能">
            </el-table-column>
            <el-table-column prop="operation_object" label="操作对象">
            </el-table-column>
            <el-table-column prop="old_data_content" label="操作前内容">
            </el-table-column>
            <el-table-column prop="new_data_content" label="操作后内容">
            </el-table-column>
            <el-table-column prop="create_time" label="操作时间">
            </el-table-column>
            <el-table-column prop="operate_nickname" label="操作人">
            </el-table-column>
          </el-table>
          <div class="block" v-if="totalPage > 1">
            <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="20"
              layout="prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getOperateDetailLogList, getClientPage } from "@/api";
import { conncectCompanyList } from '@/api/index';
export default {
  name: "OperationLog",
  data() {
    return {
      form: {
        // client_id: '',
        date: [],
        search_text: ''
      },
      currentPage: 1,
      totalCount: 0,
      totalPage: 0,
      tableData: [],
      companyList: []
    }
  },
  created() {
    this._getList();
  },
  mounted() {
    console.log(this.$route.query)
    conncectCompanyList().then(res => {
      if (0 === res.status) {
        let companyList = res.data;
        for (let item of companyList) {
          item.company_id = item.company_id + '';
        }
        this.companyList = companyList;
      } else {
        this.companyList = [];
      }
    });
  },
  methods: {
    _getList(page = 1) {
      let parameter = { ...this.form }
      if (this.form.date && this.form.date.length > 0) {
        parameter.start_date = this.form.date[0];
        parameter.end_date = this.form.date[1];
      }
      parameter.page = page
      parameter.operation_source_type = this.$route.query.type
      getOperateDetailLogList(parameter).then(res => {
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      })
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    onSearch() {
      this._getList(1);
    },
  }
}
</script>

<style scoped></style>